import { Config } from '../config';
import { FormTypes } from './form-types';
import { StripeMobilePayForm } from './stripe-mobile-pay-form';
import { PaymentType } from '../providers/payment-type';
import { Translations } from '../config/translations';
import { StripeApplePayView } from '../view/stripe-apple-pay-view';

export class StripeApplePayForm extends StripeMobilePayForm {

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }
    
    async init(config: Config, callback: any) {
        await super.init(config, callback);
        this.view = new StripeApplePayView();
        this.type = FormTypes.Stripe_Apple_Pay;
        this.paymentType = PaymentType.STRIPE_APPLE_PAY;
        this.ERROR_MESSAGE_COUNTRY_NOT_SUPPORTED = Translations.STRIPE_APPLE_PAY_COUNTRY_NOT_SUPPORTED;
        this.ERROR_MESSAGE_CREDIT_CARD_MISSING = Translations.STRIPE_APPLE_PAY_CREDIT_CARD_MISSING;
        return Promise.resolve();
    }

    shouldRenderPaymentRequestButton(result: any) {
        return result && result.applePay;
    }

    addPaymentRequestButtonSubmitEvent() {
        const elements = this.stripeAPI.elements();
        const stripePaymentRequestButton = elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest
        });
        stripePaymentRequestButton.mount('#stripe_payment_request_button');
        stripePaymentRequestButton.addEventListener('click', async (event: any) => {
            event.preventDefault();
            if (await this.config.widget.validate()) {
                this.paymentRequest.show();
            }
        });
    }

}
